import React from 'react';

import { useGetImagingDiagnosticReport } from '@hooks/api/diagnostic-report';
import { useCuration } from '@hooks/useCuration';
import { useSession } from '@hooks/useSession';

import ImagingTestsContent from './Content';

const ImagingTestsDrilldown: React.FC<{
  id?: string;
}> = ({ id = '' }) => {
  const {
    state: { activeProfile, isClient, isCurator },
  } = useSession();
  const [patient_id] = [activeProfile?.patient_id];
  const {
    state: { isCreating, isEditing },
    finishAddingRecord,
    stopEditingRecord,
  } = useCuration();

  const { data, loading } = useGetImagingDiagnosticReport({
    record_id: id,
  });

  const handleSubmit = () => {
    stopEditingRecord();
    finishAddingRecord();
  };

  return (
    <ImagingTestsContent
      canManageImgs={isCurator}
      canViewImgs={isClient}
      data={data}
      isCreating={isCreating}
      isCurator={isCurator}
      isEditing={isEditing}
      loading={loading}
      onSubmit={handleSubmit}
      patientId={patient_id}
    />
  );
};

export default ImagingTestsDrilldown;
